import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useSessionContext } from "supertokens-auth-react/recipe/session";

import { getSettings } from "../reducers/settings/settingsFunctions";
import { getRules } from "../reducers/rules/rulesFunctions";

export const AppBootstrapProvider = ({ children }) => {
    const dispatch = useDispatch();
    const { userId } = useSessionContext();
    const loadedUserId = useRef(null);

    useEffect(() => {
        if (!userId || loadedUserId.current === userId) {
            return;
        }

        loadedUserId.current = userId;
        dispatch(getSettings());
        dispatch(getRules());
    }, [userId, dispatch]);

    return children;
};